export function strip(value) {
  return value?.replace(/<\/?[^>]+>/gi, ' ') ?? '';
}
